/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function DeliveryItemEditViewDeliveryController(
    this: JS5Object,
    _: JS5Object,
    DynamicPropertiesService: JS5Object,
    LanguagesService: JS5Object,
    MetadataItemsSearchViewService: JS5Object,
    PartnerEditService: JS5Object,
    $routeParams: JS5Object
) {

    this.availableDeliveryPriorities = [
        'CRITICAL_FIRST',
        'CRITICAL_LAST',
        'NON_CRITICAL'
    ];

    this.transformDeliveryPriorityLabel = (value: string) => {
        let label = 'Unknown - Error';
        switch (value) {
            case 'CRITICAL_FIRST':
                label = 'Critical - Deliver First';
                break;
            case 'CRITICAL_LAST':
                label = 'Critical - Deliver Last';
                break;
            case 'NON_CRITICAL':
                label = 'Non-Critical';
                break;
            default :
                break;
        }
        return label;
    };

    const setVisibleFormControls = (deliveryItemType: string) => {
        switch (deliveryItemType) {
            case 'Archive':
                this.visibleFormControls = {
                    usernameExpression: true,
                    passwordExpression: true,
                    namingScheme: true,
                    targetPath: true,
                    deliveryEndpoint: true,
                    deliveryPriority: true,
                };
                break;
            case 'Artwork':
            case 'Image':
            case 'CC':
            case 'Subtitle':
            case 'Audio':
            case 'Video':
                this.visibleFormControls = {
                    usernameExpression: true,
                    passwordExpression: true,
                    namingScheme: true,
                    targetPath: true,
                    componentInventoryId: true,
                    deliveryEndpoint: true,
                    deliveryPriority: true,
                };
                break;
            case 'Metadata':
                this.visibleFormControls = {
                    usernameExpression: true,
                    passwordExpression: true,
                    namingScheme: true,
                    targetPath: true,
                    componentInventoryId: true,
                    deliveryEndpoint: true,
                    deliveryPriority: true,
                    deliveryDelay: true
                };
                break;
            default :
                this.visibleFormControls = null;
                console.warn(`Unknown delivery item type [${deliveryItemType}] when setting visibly form controls `);
                break;
        }
    };

    const requiredFormControls = {
        namingScheme: ['Archive', 'Artwork', 'Audio', 'Image', 'Metadata', 'Video']
    };

    this.isFieldRequired = (formControlName: string) => {
        return _.chain(requiredFormControls)
            .get(formControlName, [])
            .includes($routeParams.deliveryItemType)
            .value();
    };

    const getFormData = () => {
        // partner delivery endpoint collection
        PartnerEditService.getDeliveryEndpointsForPartner($routeParams.id, true)
            .then((deliveryEndpoints: Array<JS5Object>) => {
                this.availableDeliveryEndpoints = deliveryEndpoints
            });

        DynamicPropertiesService.queryForProperties().then(() => {
            LanguagesService.getAllLanguages().then((languages: JS5Object[]) => {
                this.availableLanguages = _
                    .chain(languages)
                    .orderBy('name')
                    .partition({name: 'English'})
                    .flatten()
                    .value();
            });

            // Netflix dropdown collections
            this.availableNetflixChannelMappings = _
                .sortBy(DynamicPropertiesService.getPropValueAsList('netflixPartner.channelMappings'));

            MetadataItemsSearchViewService.getPartnerMetadataProperties($routeParams.id, false)
                .then((partnerMetadataProperties: JS5Object[]) => {
                    this.availablePartnerMetadataProperties = _.orderBy(partnerMetadataProperties, 'displayName');
                });
        });
    };

    const getFullDeliveryEndpoint = () => {
        //
        // The DeliveryItemDTO includes the deliveryEndpoint
        // property; however it is the minimal form of the
        // DeliveryEndpointDTO. The DTO does not include
        // some flags that we previously needed here.
        //
        // We can get the extended form DTO from the delivery
        // endpoint collection.
        //
        // TODO: Evaluate if edit view still needs extended form DTO

        let deliveryEndpointId = _.get(this, 'editData.deliveryEndpoint.id');
        let deliveryEndpoint = _.find(this.availableDeliveryEndpoints, {id: deliveryEndpointId});

        return deliveryEndpoint;
    };

    this.showNetflixFields = () => {
        let deliveryEndpoint = getFullDeliveryEndpoint();

        let isNetflix = _.get(deliveryEndpoint, 'type') === 'Netflix';

        return isNetflix;
    };

    this.$onInit = () => {
        this.availableLanguages = [];
        this.availableNetflixChannelMappings = [];
        this.availablePartnerMetadataProperties = [];
        setVisibleFormControls($routeParams.deliveryItemType);
        getFormData();
    };
}

angular.module('prism-ui.deliveryProfiles').component('deliveryItemEditViewDelivery', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/common/delivery/delivery-items-edit-view-delivery-template.html',
    controller: DeliveryItemEditViewDeliveryController,
    bindings: {
        editData: '<'
    }
});



